import { mapFromTenant, mapFromTenants } from 'mappings/tenantMapping';
import TenantDTO, { CreateTenantDTO } from 'dto/tenants/tenantDTO';
import Tenant from 'models/tenants/tenant';
import AppError from 'utils/appError';
import http from './httpService';

//the organizations the signed-in user can switch to (GET tenant/user)
export async function apiGetTenantsForUser(accessToken: string): Promise<Tenant[]> {
  try {
    const ar = await http.get<TenantDTO[]>(`/tenant/user`, http.getRequestConfig(accessToken));

    return mapFromTenants(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//starts an organization for the directory of the signed-in user; the caller becomes its first administrator
export async function apiCreateTenant(name: string, accessToken: string): Promise<Tenant> {
  try {
    const ar = await http.post<TenantDTO>(`/tenants`, new CreateTenantDTO(name), http.getRequestConfig(accessToken));

    return mapFromTenant(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
